---
import type { TextNode, Props as $ } from "../lib/types";

export type Props = $<TextNode>;
---

<br />
